import axios from '@/libs/api.request.js'

// 获取首页数据
export const getPerformanceHomeData = (id) => {
  return axios.request({
    url: '/Performance/GetHomeData',
    params: { id },
    method: 'get'
  })
}

export const getPageList = (page, pageSize, data) => {
  return axios.request({
    url: '/Performance/GetPageList',
    params: {
      page,
      pageSize
    },
    data,
    method: 'post'
  })
}

export const getDetail = (id) => {
  return axios.request({
    url: '/Performance/GetDetail',
    params: { id },
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/performance.js